<template>
    <div>
        <app-input-form
            ref="form"
            v-bind:parentObject="{
                data: this.formData,
                pageTitle: this.pageTitle,
                pageTitleValue: this.pageTitleValue,
                errMsg: this.errMsg,
                isEdit: this.editMode,
            }"
            v-on:input="formData = $event"
            v-on:save="saveHandler"
        />
        <div v-if="isErr">
            <app-error
                v-bind:parentError="{
                    data: this.errMsg,
                    isErr: this.isErr,
                }"
                v-on:closeError="isErr = $event"
            />
        </div>
    </div>
</template>

<script>
import AttendanceIncentiveSetupForm from '../../../components/attendance/attendanceincentivesetup/Form';
import ErrorDialog from '../../../components/common/ErrorDialog';

export default {
    components: {
        'app-input-form': AttendanceIncentiveSetupForm,
        'app-error': ErrorDialog,
    },

    data() {
        return {
            pageTitle: this.$t('attendanceincentivesetup.newattendanceincentivesetup'),
            pageTitleValue: '',
            formData: {
                description: null,
                payitemid: null,
                payitemcode: null,
                payitemdesc: null,
                startdate: null,
                enddate: null,
                remark: null,
                categoryid: null,
                incentivedetail: [],
                stamp: 0,
                userid: this.$store.getters.userId,
            },
            errMsg: '',
            isErr: false,
            editMode: false,
        };
    },

    methods: {
        errorHandler($event) {
            this.isErr = $event.isErr;
            this.errMsg = $event.errMsg;
        },

        saveHandler() {
            const vm = this;

            if (!this.CheckPermission(this.$route.meta.funcname, 'canadd')) {
                return false;
            }

            this.$store.dispatch('post', { url: '/attendanceincentivesetup/create', payload: vm.formData })
                .then(res => {
                    if (res.data.error) {
                        vm.handleSaveError(res.data.error);
                    } else {
                        this.$router.push({ name: 'attndincsetuplist' });
                    }
                })
                .catch(err => {
                    vm.handleSaveError(err);
                });
        },

        handleSaveError(err) {
            const status = err && err.response ? err.response.status : null;
            const data = err && err.response ? err.response.data : null;
            const errorText = (data && (data.error || data.message)) || (typeof err === 'string' ? err : '');
            const isDuplicate = status === 409 || /description already exists/i.test(String(errorText));
            if (isDuplicate) {
                if (this.$refs.form && this.$refs.form.setDescriptionError) {
                    this.$refs.form.setDescriptionError(this.$t('attendanceincentivesetup.descriptionexists'));
                }
                return;
            }
            this.isErr = !this.isErr;
            this.errMsg = errorText || err;
        },

        cancelHandler() {
            this.$router.push({ name: 'attndincsetuplist' });
        },
    },
};
</script>
